import FirestoreType from './FirestoreType'

export default class Comment extends FirestoreType {
    get message() { return this.data.message; }
    get name() { return this.data.name; }
    get date() { return this.data.date.toDate(); }
    get uid() { return this.data.uid; }

    get projectId() { return this.path.match(/^Project\/([^/]+)/)[1]; }
}